import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .filter('frequencyDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.frequencyDisplay(
                    repeaterConfig.frequency,
                    repeaterConfig.interval
                );
            };
        })
        .filter('reminderTimeDisplay', function (PeriodicTasksService) {
            return function (reminderTime) {
                return PeriodicTasksService.reminderTimeDisplay(reminderTime);
            };
        })
        .filter('daysOfWeekDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.daysOfWeekDisplay(
                    repeaterConfig.days_of_week
                );
            };
        })
        .filter('monthsDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.monthsDisplay(
                    repeaterConfig.months
                );
            };
        })
        .filter('daysDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.daysDisplay(repeaterConfig.days);
            };
        })
        .filter('whichWhatDisplay', function (PeriodicTasksService) {
            return function (repeaterConfig) {
                return PeriodicTasksService.whichWhatDisplay(
                    repeaterConfig.which,
                    repeaterConfig.what
                );
            };
        })
        .controller('TaskDetailsController', TaskDetailsController);

    function TaskDetailsController(
        $rootScope,
        $state,
        $stateParams,
        $translate,
        ngDialog,
        toastr,
        PeriodicTasksFactory
    ) {
        var vm = this;

        init();

        function init() {
            vm.taskDetails = null;

            PeriodicTasksFactory.readOne($stateParams.id).then(function (
                response
            ) {
                vm.taskDetails = response.data;

                vm.flexMenuStructure = [
                    [
                        {
                            name: $translate.instant('common.edit'),
                            func: editTask,
                            if: true,
                        },
                        {
                            name: $translate.instant('common.delete'),
                            func: deleteTask,
                            if: true,
                            color: 'red',
                        },
                    ],
                ];
            });
        }

        function editTask() {
            $state.go('company_employee.periodic_tasks.edit_task', {
                id: $stateParams.id,
            });
        }

        function deleteTask() {
            ngDialog.open({
                template: 'deleteDialog',
                className: 'dialog-theme',
                data: {
                    item_id: $stateParams.id,
                    on_success: onDeleteSuccess,
                    delete_function: (itemId) => PeriodicTasksFactory.delete(itemId),
                },
            });

            function onDeleteSuccess() {
                $state.go(
                    'company_employee.periodic_tasks.task_list',
                    {},
                    { reload: true }
                );
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/task_details/task_details.controller.ts